import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/style-guides/page.tsx")